















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Collapse extends Vue {
  @Prop({ default: false }) value: any

  toggle() {
    this.$emit('input', !this.value)
  }
}
